module.exports = __webpack_public_path__ + "img/p7.6da6f17e.png";